import {Directive, ElementRef, HostListener} from '@angular/core';
import {ProjectUtils} from '../project-utils';

@Directive({
    selector: '[appCapitalizeFirstLetter]',
    standalone: true
})
export class CapitalizeFirstLetterDirective {

  constructor(private el: ElementRef) { }

  @HostListener('change') onChange() {
    this.formatValue();
  }

  formatValue(){
    let value = this.el.nativeElement.value;
    if(value.length>0){
      this.el.nativeElement.value = ProjectUtils.capitalizeFirstName(value);
    }
  }

}
